/**
 * 值序列化器
 *
 * Value serializer with circular reference detection and extensible type handlers.
 */
const types = new Map();
function registerType(name, def) {
    types.set(name, def);
}
// 内置类型
registerType('Date', {
    check: (v) => v instanceof Date,
    serialize: (v) => ({ __type: 'Date', value: v.toISOString() }),
    deserialize: (d) => new Date(d.value)
});
registerType('Map', {
    check: (v) => v instanceof Map,
    serialize: (v, ser) => ({ __type: 'Map', value: [...v].map(([k, val]) => [ser(k), ser(val)]) }),
    deserialize: (d) => new Map(d.value)
});
registerType('Set', {
    check: (v) => v instanceof Set,
    serialize: (v, ser) => ({ __type: 'Set', value: [...v].map(ser) }),
    deserialize: (d) => new Set(d.value)
});
function serialize(value, seen = new WeakSet()) {
    if (value == null)
        return value;
    const t = typeof value;
    if (t === 'string' || t === 'number' || t === 'boolean')
        return value;
    if (t === 'function')
        return undefined;
    const obj = value;
    if (seen.has(obj))
        return undefined;
    seen.add(obj);
    for (const [, def] of types) {
        if (def.check(value)) {
            return def.serialize(value, (v) => serialize(v, seen));
        }
    }
    if (Array.isArray(value)) {
        return value.map((v) => serialize(v, seen));
    }
    const result = {};
    for (const k of Object.keys(value)) {
        result[k] = serialize(value[k], seen);
    }
    return result;
}
function deserialize(value) {
    if (value == null)
        return value;
    const t = typeof value;
    if (t === 'string' || t === 'number' || t === 'boolean')
        return value;
    if (isTypedValue(value)) {
        const def = types.get(value.__type);
        return def ? def.deserialize(value) : value;
    }
    if (Array.isArray(value)) {
        return value.map(deserialize);
    }
    const result = {};
    for (const k of Object.keys(value)) {
        result[k] = deserialize(value[k]);
    }
    return result;
}
function isTypedValue(v) {
    if (v === null || typeof v !== 'object') {
        return false;
    }
    return '__type' in v;
}
export const ValueSerializer = {
    serialize,
    deserialize,
    register: registerType
};
//# sourceMappingURL=ValueSerializer.js.map